/**
 * Package column field mappings
 * Contains headerName and field definitions for package grid columns
 * @param {Function} t - Translation function
 * @returns {Array} Array of column field mappings with headerName and field only
 */
export const getPackageColumnFields = (t) => {
  return [
    // { 
    //   headerName: t('Package ID'), 
    //   column_name: 'package_id',
    //   is_visible: false,
    //   column_order: 1
    // },
    // { 
    //   headerName: t('Project ID'), 
    //   column_name: 'project_id',
    //   is_visible: false,
    //   column_order: 2
    // },
    {
      headerName: t('Package Name'),
      column_name: 'package_name',
      is_visible: true,
      column_order: 1
    },
    {
      headerName: t('Package Number'),
      column_name: 'package_number',
      is_visible: true,
      column_order: 2
    },
    {
      headerName: t('Package Status'),
      column_name: 'package_status',
      is_visible: true,
      column_order: 3
    },
    {
      headerName: t('MyProject Workspace Quote Number'),
      column_name: 'quote_number',
      is_visible: true,
      column_order: 4
    },
    {
      headerName: t('Fav'),
      column_name: 'favorite',
      is_visible: true,
      column_order: 5
    },
    {
      headerName: t('Copy'),
      column_name: 'Copy',
      is_visible: true,
      column_order: 6
    },
    {
      headerName: t('Import'),
      column_name: 'revision',
      is_visible: true,
      column_order: 7
    },
    {
      headerName: t('Revision History'),
      column_name: 'revision_history',
      is_visible: true,
      column_order: 8
    },
    {
      headerName: t('Project Manager'),
      column_name: 'project_manager',
      is_visible: true,
      column_order: 9
    },
    {
      headerName: t('Project Engineer'),
      column_name: 'project_engineer',
      is_visible: true,
      column_order: 10
    },
    {
      headerName: t('Sold To Customer'),
      column_name: 'sold_to_cust',
      is_visible: true,
      column_order: 11
    },
    {
      headerName: t('Customer number'),
      column_name: 'customer_number',
      is_visible: true,
      column_order: 12
    },
    {
      headerName: t('Party Site number'),
      column_name: 'party_site_number',
      is_visible: true,
      column_order: 13
    },
    {
      headerName: t('Alternate name'),
      column_name: 'alternate_name',
      is_visible: true,
      column_order: 14
    },
    {
      headerName: t('Address1'),
      column_name: 'address1',
      is_visible: true,
      column_order: 15
    },
    {
      headerName: t('Address2'),
      column_name: 'address2',
      is_visible: true,
      column_order: 16
    },
    {
      headerName: t('City'),
      column_name: 'city',
      is_visible: true,
      column_order: 17
    },
    {
      headerName: t('State'),
      column_name: 'state_province',
      is_visible: true,
      column_order: 18
    },
    {
      headerName: t('Country'),
      column_name: 'country',
      is_visible: true,
      column_order: 19
    },
    {
      headerName: t('Postal Code'),
      column_name: 'postal_code',
      is_visible: true,
      column_order: 20
    },
    {
      headerName: t('End User Customer'),
      column_name: 'end_user_cust',
      is_visible: true,
      column_order: 21
    },
    {
      headerName: t('End Destination'),
      column_name: 'end_dest',
      is_visible: true,
      column_order: 22
    },
    {
      headerName: t('End Customer Proj Reference'),
      column_name: 'end_cust_prj_ref',
      is_visible: true,
      column_order: 23
    },
    {
      headerName: t('Sold To Customer Package Reference ID'),
      column_name: 'sold_to_cust_pkg_ref',
      is_visible: true,
      column_order: 24
    },
    {
      headerName: t('Sales Office Requested Date'),
      column_name: 'sales_office_req_date',
      is_visible: true,
      column_order: 25
    },
    {
      headerName: t('World Area Sales Org'),
      column_name: 'world_area_sales_org',
      is_visible: true,
      column_order: 26
    },
    {
      headerName: t('Sales Representative'),
      column_name: 'sales_representative',
      is_visible: true,
      column_order: 27
    },
    {
      headerName: t('CRM Quote ID'),
      column_name: 'crm_quote_id',
      is_visible: true,
      column_order: 28
    },
    {
      headerName: t('Currency'),
      column_name: 'currency',
      is_visible: true,
      column_order: 29
    },
    {
      headerName: t('Pricing Region'),
      column_name: 'pricing_region',
      is_visible: true,
      column_order: 30
    },
    {
      headerName: t('Pricing Date'),
      column_name: 'pricing_date',
      is_visible: true,
      column_order: 31
    },
    {
      headerName: t('Fiscal Year Price'),
      column_name: 'fiscal_year_price',
      is_visible: true,
      column_order: 32
    },
    {
      headerName: t('Price List'),
      column_name: 'price_list',
      is_visible: true,
      column_order: 33
    },
    // { 
    //   headerName: t('MyProject Workspace ID'), 
    //   column_name: 'project_ws_id',
    //   is_visible: false,
    //   column_order: 35
    // },
    {
      headerName: t('Created By'),
      column_name: 'created_by',
      is_visible: true,
      column_order: 34
    },
    {
      headerName: t('Created Date'),
      column_name: 'creation_date',
      is_visible: true,
      column_order: 35
    },
    {
      headerName: t('Last Updated By'),
      column_name: 'last_updatedby',
      is_visible: true,
      column_order: 36
    },
    {
      headerName: t('Last Updated Date'),
      column_name: 'last_updatedate',
      is_visible: true,
      column_order: 37
    },
    {
      headerName: t('Active Revision'),
      column_name: 'active_revision',
      is_visible: true,
      column_order: 38
    },
    {
      headerName: t('Max Revision'),
      column_name: 'max_revision',
      is_visible: true,
      column_order: 39
    },
  ];
};
